module.exports = {
	"projectID": "home",
	"title": "Home",
	"pageContent": [
		{
			"type": "tagline",
			"className": "no-top-padding",
			"title": "We build the creative&nbsp;web"
		},
		{
			"type": "workgrid",
			"workgridItems": [
				{
					"type": "Work",
					"title": "twitter marketing",
					"url": "/work/twitter-marketing",
					"icon": "/images/twtr-logo.png",
					"img": "/images/home-workgrid/mtc-sq.jpg",
					"size": "md"
				},
				{
					"type": "Work",
					"title": "twitter flight school",
					"url": "/work/twitter-flight-school",
					"icon": "/images/twtr-logo.png",
					"img": "/images/home-workgrid/fs-sq.jpg",
					"size": "md"
				},
				{
					"type": "Labs",
					"title": "metagramme",
					"url": "/labs/metagramme",
					"icon": "/images/metagramme-logo.png",
					"img": "/images/home-workgrid/metagramme-sq.jpg",
					"size": "sm"
				},
				{
					"type": "Work",
					"title": "Airbnb<br>maisons de france",
					"url": "/work/airbnb-maisons-de-france",
					"icon": "/images/airbnb-logo.png",
					"img": "/images/home-workgrid/abb-mdf-sq.jpg",
					"size": "sm"
				},
				{
					"type": "Work",
					"title": "eventbrite<br>prototype",
					"url": "/work/eventbrite-prototype",
					"icon": "/images/eventbrite-logo.png",
					"img": "/images/home-workgrid/eb-prototype-sq.jpg",
					"size": "sm"
				},
				{
					"type": "Work",
					"title": "hmz",
					"url": "/work/sony-hmz",
					"icon": "/images/sony-logo.png",
					"img": "/images/home-workgrid/sony-hmz-sq.jpg",
					"size": "sm"
				},
				{
					"type": "Work",
					"title": "airbnb<br>road trips",
					"url": "/work/airbnb-road-trips",
					"icon": "/images/airbnb-logo.png",
					"img": "/images/home-workgrid/abb-road-trippers-sq.jpg",
					"size": "sm"
				},
				{
					"type": "Labs",
					"title": "moonphase",
					"url": "/labs/moonphase",
					"icon": "/images/martian-logo.png",
					"img": "/images/home-workgrid/moonphase-sq.jpg",
					"size": "sm"
				},
				{
					"type": "labs",
					"title": "scrum poker",
					"url": "/labs/scrum-poker",
					"icon": "/images/martian-logo.png",
					"img": "/images/home-workgrid/scrumpoker-sq.jpg",
					"size": "sm"
				},
				{
					"type": "labs",
					"title": "twitter<br>fingerprint",
					"url": "/labs/twitter-fingerprint",
					"icon": "/images/martian-logo.png",
					"img": "/images/home-workgrid/twitter-fingerprint-sq.jpg",
					"size": "sm"
				},
				{
					"type": "Work",
					"title": "merrill<br>infographics",
					"url": "/work/merrill-infographics",
					"img": "/images/home-workgrid/merrill-infographics-sq.jpg",
					"icon": "/images/merrill-logo.png",
					"size": "sm"
				},
				{
					"type": "Work",
					"title": "telenav<br>thinknear",
					"url": "/work/thinknear",
					"icon": "/images/thinknear-logo.png",
					"img": "/images/home-workgrid/thinknear-sq.jpg",
					"size": "sm"
				},
				{
					"type": "work",
					"title": "mede<br>analytics",
					"url": "/work/mede-analytics",
					"icon": "/images/mede-logo.png",
					"img": "/images/home-workgrid/mede-analytics-sq.jpg",
					"size": "sm"
				},
				{
					"type": "Labs",
					"title": "Serenade",
					"url": "/labs/serenade",
					"icon": "/images/martian-logo.png",
					"img": "/images/home-workgrid/serenade-sq.jpg",
					"size": "sm"
				}
			]
		},
		{
			"type": "tagline",
			"title": "Interested in working with us?<br><a href='mailto:hello@martian.com'>hello@martian.com</a>"
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/data/home.json
 ** module id = 222
 ** module chunks = 0
 **/